/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { create_payment, set_value_payment } from "../../App/actions/paymentActions";

/*PICTURE*/
import icon_gift from "../../Assets/svg/gift.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import { set_value_user } from "../../App/actions/authActions";

/*CONST*/

class RedeemPopup extends Component {
  toggle_modal_payment = () => {
    this.props.set_value_payment({
      key: "is_able_to_greeting_page",
      value: false,
    })

    this.props.set_value_user("modal_payment_universal", true);
  };

  render() {
    const { language } = this.props;

    //content
    return (
      <div className="sidebar_button vertical_center w_200 hover_lightGrey">
        <div
          onClick={this.toggle_modal_payment}
          className="vertical_center_child"
        >
          <div style={{ marginLeft: "20px" }}>
            <img src={icon_gift} alt={"Redeem"} width="35px" />
          </div>
          <div
            className="text_medium"
            style={{ marginLeft: "20px", width: "250px", color: "black" }}
          >
            {dict?.["View Plans"]?.[language]}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_properties,
  create_payment,
  set_value_user,
  set_value_payment
})(RedeemPopup);
